<template>
  <div id="user">
      <!-- 面包线导航 -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome?'+ new Date()}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户</el-breadcrumb-item>
      </el-breadcrumb>
        <!-- 卡片视图 -->
      <el-card >
                <!-- 第一行筛选框 -->
            <el-row :gutter="20">
                    <!-- 机器名查询 -->
                    <el-col :span="6" >
                        <span>姓名:</span>
                        <el-input placeholder="请输入姓名" v-model="queryInfo.name" class="m-l-30 ell-input" ></el-input>
                    </el-col>
                    <!-- 机器地址查询 -->
                    <el-col :span="6">
                        <span>手机号:</span>
                        <el-input placeholder="请输入手机号" v-model="queryInfo.phone" class="m-l-30 ell-input" ></el-input>
                    </el-col>
                    <!-- 设备是否在线 -->
                    <el-col :span="6">
                    <span>用户状态:  </span>
                    <el-select v-model="queryInfo.status" placeholder="请选择" class="m-l-30 elll-input">
                            <el-option v-for="item in userStatus" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                     <!-- 创建时间 -->
                    <el-col :span="6">
                        <span>创建时间:  </span>
                        <el-date-picker v-model="queryInfo.createTime"  type="date"  value-format="yyyy-MM-dd"  placeholder="选择日期" class="m-l-30"> </el-date-picker>
                    </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col align="middle" >
                    <el-button type="primary" @click="searchUsers()">查询</el-button>
                    <el-button type="primary" @click="showAddDialogVisible()" >添加用户</el-button>
                    <el-button type="info" @click="clearParams()">重置</el-button>
                </el-col>  
            </el-row> 
            <!-- 用户列表区域   -->
            <el-table :data="userList" border  stripe :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
                    <el-table-column label="序号"   type="index" width="80"></el-table-column>
                    <el-table-column label="姓名"   prop="name" width="130"></el-table-column>
                    <el-table-column label="登录名" prop="username" width="180"></el-table-column>
                    <el-table-column label="手机号" prop="phone" width="130"></el-table-column>
                    <el-table-column label="邮箱"   prop="email" width="180"></el-table-column>
                    <el-table-column label="所属公司"   prop="companyName" width="280">
                        <template   slot-scope="scope">
                            <span v-if="scope.row.companyName===null">
                               系统管理员
                            </span>
                            <span v-if="scope.row.companyName!==null">
                                    {{scope.row.companyName}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="角色"  width="130">
                        <template   slot-scope="scope">
                        <span v-if="scope.row.role===null">
                               暂无角色
                        </span>
                        <span v-if="scope.row.role!==null">
                                {{scope.row.role.nameZh}}
                        </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
                    <el-table-column label="禁用/启用" width="100" >
                        <template slot-scope="scope">
                            <!--用户自己不能设置企业禁用自己-->
                            <span v-if="scope.row.username!='admin'  && currentUser.id!=scope.row.id">
                                <el-switch v-model="scope.row.status"  active-value="0" inactive-value="1"  @change="userStatusChange(scope.row)"></el-switch>
                            </span>
                             <span v-if="scope.row.username=='admin' || currentUser.id==scope.row.id">
                                <el-switch v-model="scope.row.status"  active-value="0" inactive-value="1"  @change="userStatusChange(scope.row)" disabled></el-switch>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" >
                        <template slot-scope="scope">
                            <!--当前用户角色 admin-->
                            <span v-if="  currentRole.name=='admin'  ">
                                <!-- 编辑按钮 -->
                                <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false"  v-if="scope.row.role==null || scope.row.role.name!='admin'">
                                    <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
                                </el-tooltip>
                                <!-- 删除按钮 -->
                                <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  v-if=" scope.row.role==null || scope.row.role.name!='admin'">  
                                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row)"></el-button>
                                </el-tooltip>
                            </span>
                            <!--当前用户角色非超管-->
                            <span v-if="  currentRole.name!='admin' ">
                                <!-- 编辑按钮 -->
                                <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false"  >
                                    <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
                                </el-tooltip>
                                <!-- 删除按钮 -->
                                <el-tooltip effect="dark" content="删除" placement="top" :enterable="false" v-if="currentUser.id!==scope.row.id">  
                                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row)"></el-button>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
            </el-table>
            <!-- 超管添加用户 -->
            <el-dialog title="添加用户"  :visible.sync="addDialogVisible"  width=" 50%" @close="addDialogClose" class="dialog">
                <!-- 内容主题主区 -->
                <el-form ref="addUserFromRef" :model="addUserFrom"  :rules="addUserFromRules" label-width="50%">
                    <el-row>
                         <el-col :span="12">
                                <el-form-item label="账号:" label-width="90px" prop="username">
                                    <el-input v-model="addUserFrom.username"   placeholder="请输入用户账号"  style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="名称:" label-width="90px" prop="name">
                                    <el-input v-model="addUserFrom.name" placeholder="请输入用户名称"  auto-autocomplete=“off” style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="密码:" label-width="90px" prop="password">
                                    <el-input v-model="addUserFrom.password" placeholder="请输入密码"  auto-complete="new-password" show-password style="width:80%" @input="change($event)" ></el-input>
                                </el-form-item>
                                <el-form-item label="邮箱:" label-width="90px" prop="email">
                                    <el-input v-model="addUserFrom.email" placeholder="请输入邮箱"  style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="号码:" label-width="90px" prop="phone">
                                    <el-input v-model="addUserFrom.phone" placeholder="请输入电话号码" style="width:80%"   ></el-input>
                                </el-form-item>
                                <el-form-item label="所属角色:" label-width="90px" prop="roleId">
                                    <el-select v-model="addUserFrom.roleId" value-key="id" style="width:80%" placeholder="请选择" @change="changeRole"  :disabled="addEditFlag">
                                            <el-option v-for="item in roles" :key="item.id"  :label="item.nameZh" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="所属企业:" label-width="90px"  prop="companyId"  v-if="managerFalg" >
                                    <el-select v-model="addUserFrom.companyId" value-key="id" style="width:80%" placeholder="请选择" :disabled="addEditFlag" >
                                            <el-option v-for="item in companys" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                          </el-col>
                    </el-row>
                </el-form>
                <!-- 底部区 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addUser()">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 修改对话框 -->
             <el-dialog title="修改用户"  :visible.sync="editDialogVisible"  width="50%" @close="editDialogClose" class="dialog">
                <!-- 内容主题主区 -->
                <el-form ref="editFeomRef" :model="editFeom"  :rules="editFeomRules" label-width="50%">
                    <el-row>
                         <el-col :span="10">
                                <el-form-item label="账号:" label-width="80px" prop="userName">
                                    <el-input v-model="editFeom.username" placeholder="请输入用户账号"  style="width:80%" disabled ></el-input>
                                </el-form-item>
                                <el-form-item label="名称:" label-width="80px" prop="name">
                                    <el-input v-model="editFeom.name" placeholder="请输入用户名称"  auto-autocomplete=“off” style="width:80%" disabled ></el-input>
                                </el-form-item>
                                <el-form-item label="密码:" label-width="80px" prop="password">
                                    <el-input v-model="editFeom.password" placeholder="请输入密码"  auto-complete="new-password" show-password style="width:80%" @input="change($event)" ></el-input>
                                </el-form-item>
                                <el-form-item label="邮箱:" label-width="80px" prop="email">
                                    <el-input v-model="editFeom.email" placeholder="请输入邮箱"  style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="号码:" label-width="80px" prop="phone">
                                    <el-input v-model="editFeom.phone" placeholder="请输入电话号码" style="width:80%"   ></el-input>
                                </el-form-item>
                                <el-form-item label="用户角色:" label-width="80px">
                                    <el-select v-model="editFeom.roleId" value-key="id" style="width:80%" placeholder="请选择" @change="changeRoles"   :disabled=" currentRole.name!='admin' ||   editFeom.editManagerFlag">
                                            <el-option v-for="item in roles" :key="item.id"  :label="item.nameZh" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="所属企业:" label-width="80px"  v-if="editFeom.roleName=='putong' || editFeom.roleName=='manager'">
                                    <el-select v-model="editFeom.companyId" value-key="id" style="width:80%" placeholder="请选择" :disabled="currentRole.name!='admin' ||  editFeom.editManagerFlag" >
                                            <el-option v-for="item in companys" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                          </el-col>
                          <el-col v-if="currentUser.id!=editFeom.id  && (editFeom.roleName=='putong' || editFeom.roleName=='manager')"  :span="12">
                                    <span id="old"><el-input placeholder="请输入机器人编号" v-model="robotNo"  />
                                        <el-button type="primary"  @click="selectRobot(robotNo)">查询</el-button>
                                         <el-table ref="multipleTable"  :data="robotList" height="250" border style="width:100%" >
                                                  <el-table-column label="序号"   type="index" width="80"></el-table-column>
                                                  <el-table-column label="机器编号"   prop="robotNo" width="140"></el-table-column>
                                                  <el-table-column label="机器名称"   prop="robotName" width="140"></el-table-column>
                                                  <el-table-column label="操作" width="60" >
                                                    <template slot-scope="scope">
                                                        <!-- 编辑按钮 -->
                                                        <el-tooltip effect="dark" content="添加" placement="top" :enterable="false">
                                                            <el-button type="primary" icon="el-icon-plus" size="mini" @click="addRobot(scope.row)"></el-button>
                                                        </el-tooltip>
                                                    </template>
                                                  </el-table-column>
                                        </el-table>
                                    </span>
                                    <span id="new" >绑定机器人
                                        <el-table ref="multipleTable" tooltip-effect="dark" :data="newRobots" >
                                                 <el-table-column label="序号"   type="index" width="80"></el-table-column>
                                                  <el-table-column label="机器编号"   prop="robotNo" width="140"></el-table-column>
                                                  <el-table-column label="机器名称"   prop="robotName" width="140"></el-table-column>
                                                  <el-table-column label="操作" width="60" >
                                                    <template slot-scope="scope">
                                                        <!-- 编辑按钮 -->
                                                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                                                            <el-button type="primary" icon="el-icon-minus" size="mini" @click="deleteRobot(scope.row)"></el-button>
                                                        </el-tooltip>
                                                    </template>
                                                  </el-table-column>
                                        </el-table>
                                    </span>
                          </el-col>
                    </el-row>
                    
                </el-form>
                <!-- 底部区 -->
                 <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editUser()">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 分页区间 -->
            <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="queryInfo.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
            </el-pagination>
      </el-card>
  </div>
</template>

<script>
//引入json格式化
export default {
  name: 'user',
  //数据渲染
  data(){
      //校验手机号   rule 规则   value  值  cb 回调
        var checkphone=(rule,value,cb)=>{
            const  regPhone=/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/
            if(regPhone.test(value)){
                return cb();
            }
            cb(new Error('请输入合法的手机号!'))
        }
        var checkLoginName=(rule,value,cb)=>{
            const  regLoginName=/^[0-9a-zA-Z]*$/
            if(regLoginName.test(value)){
                return cb();
            }
            cb(new Error('请输入数字或字母!'))
        }
        var checkZF=(rule,value,cb)=>{
            var zF = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
       }
       var  checkpassword = (rule, value, callback) => {
            const age= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
            if (!age.test(value)) {
                callback(new Error('请输入长度为6到16 字母和数字！'))
            }else{
                callback()
            }
      }
      return {
          queryInfo:{
              name:'',
              phone:'',
              status:'',
              createTime:'',
              num:1
          },
          robotNo:'',
          userList:[],
          show:true,
          total:0,
          rank:'',
          //控制对话框的显示
          addDialogVisible :false,
          editDialogVisible:false,
          //添加用户的表单数据
          addUserFrom: {
              username:'',
              name:'',
              password:'',
              phone:'',
              email:''
          },
          robotList:[],
          newRobots:[],
          userStatus:[
             {
                value: '0',
                label: '启用'
            }, {
                value: '1',
                label: '禁用'
            }
          ],
          roles:[
        
          ],
          companys:[
        
          ],
          //添加用户的校验规则
          addUserFromRules:{
             name: [{required: true, message: '请输入用户名!',  trigger: 'blur' },{ min: 2,  max: 8,  message: '长度在 2 到 8 个字符!',   trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
             username:[{required: true, message: '请输入登录名!',  trigger: 'blur' },{ min: 5,  max: 12, message: '长度在 5 到 12 个字符!',  trigger: 'blur' } ,{ validator : checkLoginName, trigger: 'blur'}],
             password: [{required: true, message: '请输入密码!',    trigger: 'blur' },{ min: 6,  max: 16, message: '长度在 6 到 16 个字符!',  trigger: 'blur' },{ validator : checkpassword, trigger: 'blur'}],
             phone:    [{required: true, message: '请输入手机号!',  trigger: 'blur' },{ min: 11, max: 11, message: '长度为11字符!',           trigger: 'blur'} ,{ validator : checkphone, trigger: 'blur'}],
             roleId:[{required: true, message: '请选择角色!',  trigger: 'blur' },],
             companyId:[{required: true, message: '请选择角色!',  trigger: 'blur' },]
          },
          editFeom:{
            parentId:'',
            roleName:'',
            editManagerFlag:false   //企业用户默认不允许编辑
          },
          editFeomRules:{
               password: [{required: true, message: '请输入密码!',    trigger: 'blur' },{ min: 6,  max: 16, message: '长度在 6 到 16 个字符!',  trigger: 'blur' },{ validator : checkpassword, trigger: 'blur'}],
               phone:    [{required: true, message: '请输入手机号!',  trigger: 'blur' },{ min: 11, max: 11, message: '长度为11字符!',           trigger: 'blur'},{ validator : checkphone, trigger: 'blur'}]
          },
          currentRole:'',
          currentUser:'',
          managerFalg:true,
          addEditFlag:false,
      }
  },
  //生命周期函数
  created(){
    this.getUserList();
    this.init()
  },
  methods:{
    //用户选择角色
    changeRole(val){
        
        var role=null;
        for(var i=0;i<this.roles.length;i++){
            var roleTrmp=this.roles[i];
            if(roleTrmp.id==val){
                role=roleTrmp;
            }
        }
        var name=role.name;
        if("putong"==name || "manager"=== name){
            this.managerFalg=true;
        }else{ 
            this.managerFalg=false;
        }
    },
    //清空筛选机器人条件 
    changeManagers(){
        this.robotList=[];
        this.robotNo='';
        this.newRobots=[];
    },
    showAddDialogVisible(){
        this.addDialogVisible=true;
        this.$set(this.$data.addUserFrom,'roleId','') 
        this.$set(this.$data.addUserFrom,'companyId','')  
        //普通管理员
        if(this.currentRole.name==="manager"){
            this.addEditFlag=true;
            for(var i=0;i<this.roles.length;i++){
               var role =this.roles[i]
               if(role.name=="putong"){
                    this.addUserFrom.roleId=role.id;
               }
            }
            this.addUserFrom.companyId=this.currentUser.companyId;
        }
    },
    init(){
         this.currentRole=this.$cookies.get("role")
         this.currentUser=this.$cookies.get("user")
         this.$http.get('/role/listRoles')
         .then(response => {
                if (response.data.code === 200) {
                   if("manager"===this.currentRole.name){
                        this.roles=[];
                        var roles=response.data.result
                        if(roles!==undefined && roles.length>1 ){
                            for(var i=0;i<roles.length;i++){
                               var role= roles[i]
                               if("putong"===role.name || "manager"===role.name){
                                    this.roles.push(role)
                               }
                            }
                        }
                   }else{
                        this.roles=response.data.result
                   }
                }else{
                     return this.$message.error(response.data.msg);
                }
            }).catch(failResponse => {

        })
        //查询企业
        this.$http.get('user/allCompany').then(response => {
             if (response.data.code === 200) {
                this.companys=response.data.result
             }
        })
    },
    change(e) {
      this.$forceUpdate()
    },
    //根据角色隐藏绑定机器人
    changeRoles(val){
        if(this.roles.length>0){
            for(var i=0;i<this.roles.length;i++){
                var role=this.roles[i];
                if(role.id===val){
                    this.editFeom.roleName=role.name;
                }
            }
        }
        this.robotList=[];
        this.newRobots=[];
        this.$set(this.$data.editFeom,'parentId','')  
        this.robotNo='';
    },
    //添加绑定机器人
    addRobot(row){
        if(this.newRobots!==[]){
             for (var i = 0; i < this.newRobots.length; i++) {
                    if(row.robotNo==this.newRobots[i].robotNo){
                        this.$message.error("该机器已在绑定列表中!");
                        return;
                    }
             }
            this.newRobots.push(row)
        }else{
            var tempWorkList = []
            tempWorkList.push(row);
            this.newRobots=tempWorkList;
        }

    },
    deleteRobot(row){
        if(this.newRobots.length>0){
           for (var i = 0; i < this.newRobots.length; i++) {
                    if(row.robotNo==this.newRobots[i].robotNo){
                        this.newRobots.splice(i, 1);
                    }
             }
        }
    },
    selectRobot(){
        if(this.editFeom.roleName==='putong' &&  (this.editFeom.companyId===undefined ||this.editFeom.companyId===0 ||this.editFeom.companyId==="" )){
            return this.$message.error("请选择所属企业!");
        }
        let params={
            robotNo:this.robotNo,
            companyId:this.editFeom.companyId,
            userId:this.editFeom.id,
            roleName:this.editFeom.roleName
        }
        this.$http.post('/robot/selectBindRobot',JSON.stringify(params))
        .then(response => {
                if (response.data.code === 200) {
                    this.robotList=response.data.result
                }else{
                     return this.$message.error(response.data.message);
                }
            }).catch(failResponse => {

        })
    },
    //查询用户
    getUserList(){
        var check = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
        if(check.test(this.queryInfo.name)||check.test(this.queryInfo.phone)){
            return this.$message.error("请输入非特殊字符!");
        }
        this.$http.post('/user/selectUser',JSON.stringify(this.queryInfo))
        .then(response => {
                if (response.data.code === 200) {
                    this.userList=response.data.result.data
                    this.total=response.data.result.total
                }else{
                     return this.$message.error(response.data.message);
                }
            }).catch(failResponse => {

        })
      },
      //添加用户
      addUser(){
            let email=this.addUserFrom.email
            if(email!==null && email!==""){
                const  regPhone=/^\w+@[a-z0-9]+\.[a-z]{2,4}$/
                if(!regPhone.test(email)){
                    this.$message.error("输入正确邮箱号!");
                    return
                }
            }
            this.$refs.addUserFromRef.validate(  valid => {
                if(!valid){  return;}
                 this.$http.post('/user/addUser',JSON.stringify(this.addUserFrom)) .then(response => {
                if (response.data.code === 200) {
                     this.$message.success("新增成功!");
                     this.getUserList();
                     this.addDialogVisible=false
                    return 

                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {

                })
            })
      },
      editUser(){
          this.$refs.editFeomRef.validate(  valid => {
                        if(!valid){  return;}
                        var that=this;
                        this.editFeom.robots=this.newRobots
                        this.$http.post('user/updateUser',JSON.stringify(that.editFeom))  .then(response => {
                        if (response.data.code === 200) {
                            that.$message.success("更新成功!");
                            that.getUserList();
                            that.editDialogVisible=false
                        }else{
                            return that.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {
                })
            })
      },
      //根据id删除
      async deleteById(obj){
        //普通人员删除
        const confirmRes='';
        if(obj.role!=null && obj.role.name=="manager"){
            const confirmRes= await this.$confirm('此操作将永久该用户及所属的普通管理员, 是否继续?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err =>{
                return err
            })
              //管理员删除
            if(confirmRes !=='confirm'){
                return this.$message.info('已经取消删除')
            }
        }else{
            const confirmRes= await this.$confirm('此操作将永久删除用户, 是否继续?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err =>{
                return err
            })
              //管理员删除
            if(confirmRes !=='confirm'){
                return this.$message.info('已经取消删除')
            }
        }
         this.$http.get('/user/deleteUser',{params :{ id :  obj.id }})
         .then(response => {
                if (response.data.code === 200) {
                    this.$message.success("删除成功!");
                    this.getUserList();
                }else{
                     return this.$message.error(response.data.msg);
                }
            }).catch(failResponse => {

        })
      },
      //点击指定页码跳转
      handleCurrentChange(page){
        this.queryInfo.num=page;
        this.getUserList();
      },
      //监听状态改变
      userStatusChange(data){
        this.$http.get('user/updateUserStatus?',{params: { status:data.status,id : data.id }})
        .then(response => {
                if (response.data.code === 200) {
                    return this.$message.success("更新成功")
                }else{
                     return this.$message.error(response.data.msg);
                }
            }).catch(failResponse => {

        })
      },
      async userAcmsgChange(data){
        const {data:res}=await this.$http.get('/updateAcmsg',{params :{ acmsg:data.acmsg,id : data.id }})
         if(res.code ===8){ 
            this.$message.error(res.msg);
            this.$router.push('/login') 
        }
        if(res.code!==0){
             return this.$message.error(res.msg)
        }else{
            return this.$message.success(res.msg)
        }
      },
      //添加对话框关闭,清空数据
      addDialogClose(){
          this.$refs.addUserFromRef.resetFields();
          this.$set(this.$data.addUserFrom,'roleId','')  
          this.managerFalg=true;
      },
        //展示编辑对话框
      async showEditDialog(id){
         var that=this
         this.$http.get('user/getEditUser',{params :{ id :  id }})
          .then(response => {
                if (response.data.code === 200) {
                    that.editFeom=response.data.result.user
                    if(that.editFeom.companyId===0){
                        that.editFeom.companyId=null;
                    }
                    if(that.editFeom.role==null){
                        return this.$message.error("该用户没有绑定角色,无法进行编辑");
                    }
                    that.editFeom.roleId=that.editFeom.role.id
                    that.editFeom.roleName=that.editFeom.role.name
                    if( that.editFeom.roleName==="manager"){
                        that.editFeom.editManagerFlag=true
                    }
                    if( that.editFeom.role.name=='putong' || that.editFeom.role.name=='manager'){
                        that.newRobots=response.data.result.robots;
                        that.show=true;
                    }else{
                        that.show=false;
                    }
                    that.robotList=response.data.result.robotList
                    that.editDialogVisible=true;
                    //查询当前能绑定的机器人
                }else{
                      return that.$message.error(res.message);
                }
            }).catch(failResponse => {
               
        })
        
      },
      //监听修改对话看
      editDialogClose(){
          this.$refs.editFeomRef.resetFields();
          this.robotList=[];
          this.robotNo='';
          this.newRobots=[];
      },
            //查询用户
      searchUsers(){
        this.getUserList();
      },
        //清空查询条件
      clearParams(){
        this.queryInfo.name=''
        this.queryInfo.phone=''
        this.queryInfo.status=''
        this.queryInfo.createTime=''
        this.queryInfo.num=1
    }
  }
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 180px;
}
.elll-input {
    width: 150px;
}
.m-l-30 {
  margin-left: 10px !important;
}
.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}
.span{
    margin:20px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
.dialog {
    font-size: 14px;
    font-weight: bold;
    align-content: center;
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/user/User.vue